var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-alert"},_vm._l((_vm.alertData),function(alert,index){return _c('v-alert',{key:index,attrs:{"type":alert.type}},[_vm._v(" "+_vm._s(alert.message)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }